import * as actionTypes from './types';

export const setInternalSettings = (internalData) => {
  return {
    type: actionTypes.SET_INTERNAL_SETTINGS,
    value: internalData,
  };
};

export const setError = (error) => {
  return {
    type: actionTypes.SET_ERROR,
    value: error,
  };
};

export default setInternalSettings;
